import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from "@angular/router";
import { Observable, from, of } from "rxjs";
import { UserService } from "../services/user.service";
import { map, switchMap } from "rxjs/operators";

@Injectable({ providedIn: 'root' })
// protects routes from unauthenticated users
export class AuthGuard {
  constructor(private router: Router, private userService: UserService) { }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> {
    let hasRoles = route.data['roles'] as string[];
    return from(this.userService.init()).pipe(
      switchMap(() => {
        if (hasRoles) {
          for (let role of hasRoles) {
            if (!this.userService.IsInRole(role)) {
              return of(false);
            }
          }
        }
        return this.isSignedIn();
      })
    );
  }

  canActivateChild(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> {
    let hasRoles = route.data['roles'] as string[];
    return from(this.userService.init()).pipe(
      switchMap(() => {
        if (hasRoles) {
          for (let role of hasRoles) {
            if (!this.userService.IsInRole(role)) {
              return of(false);
            }
          }
        }
        return this.isSignedIn();
      })
    );
  }

  isSignedIn(): Observable<boolean> {
    return from(this.userService.init()).pipe(
      switchMap(() => {
        let isSignedIn = this.userService.isSignedIn;
        if (!isSignedIn) {
          this.router.navigate(['/identity/signin']);
        }
        return of(isSignedIn);
      })
    );
  }
}
